import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NotFoundContainer = styled.div`
  text-align: center;
  padding: 4rem 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--gray-800);
`;

const Description = styled.p`
  font-size: 1.125rem;
  color: var(--gray-600);
  margin-bottom: 2rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

const HomeButton = styled(Link)`
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius);
  font-weight: 500;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: var(--primary-light);
    text-decoration: none;
  }
`;

function NotFound() {
  return (
    <NotFoundContainer>
      <Title>404 - Page Not Found</Title>
      <Description>
        The page you are looking for doesn't exist or has been moved.
      </Description>
      <HomeButton to="/">Back to Dashboard</HomeButton>
    </NotFoundContainer>
  );
}

export default NotFound;